<template>
  <div>
    <router-view></router-view>
    <div class="width-wrapper relative">

      <div class="rack-list" title="">

        <div class="rack-list-item"
             v-for="rack in racks"
             title=""
        >

          <div v-if="rack.has_changes && $store.state.user.role === 'HM'" class="has-changes"></div>
          <div class="rack-list-item__name" :id="rack.id">

            <span @click="$router.push(`/pharmacies/${pharmacy}/racks/${rack.id}/`)">{{rack.title}}</span> </div>
          <div class="rack-list-item__group"></div>

          <div title="" class="rack-list-shelf"
               v-for="(shelf,index) in rack.shelfs"
               :class="shelf.template_shelf !== null? 'rack-list-shelf--template' : ''"
          >

            <div class="has-changes" v-if="shelf.has_changes"></div>

            <div v-if="shelf.template_shelf === null">

              <div @click="$router.push(`/pharmacies/${pharmacy}/racks/${rack.id}/${shelf.id}/`)">
                <img :src="shelf.photo" alt="" class="rack-list-shelf__image new-ver" v-if="$store.state.user.role === 'HM'">
                <img :src="shelf.lastVerPhoto" alt="" class="rack-list-shelf__image last-ver" v-else>
                <div class="rack-list-shelf__number"># {{rack.shelfs.length - (index)}}</div>


              </div>

              <div class="rack-list-operations-module" v-if="$store.state.user.role === 'HM'">
                <a  @click="$router.push(`/pharmacies/${pharmacy}/racks/${rack.id}/${shelf.id}/`)" class="top-nav__link">Перейти</a>
                <a  @click="$router.push(`/pharmacies/${pharmacy}/racks/${rack.id}/${shelf.id}/copy/`)" class="top-nav__link">Скопировать</a>
                <a  @click="$router.push(`/pharmacies/${pharmacy}/racks/${rack.id}/${shelf.id}/template/`)" class="top-nav__link">Заменить эталонной</a>
              </div>
            </div>


            <div v-if="shelf.template_shelf !== null">
              <div @click="$router.push($store.state.user.role === 'HM' ? `/pharmacies/${shelf.template_shelf.pharmacy}/racks/${shelf.template_shelf.rack}/${shelf.template_shelf.id}/` : `/pharmacies/${pharmacy}/racks/${rack.id}/${shelf.id}/`)">
                <img :src="shelf.template_shelf.photo" alt="" class="rack-list-shelf__image new-ver" v-if="$store.state.user.role === 'HM'">
                <img :src="shelf.lastVerPhoto" alt="" class="rack-list-shelf__image last-ver" v-else>
                <div class="rack-list-shelf__number"># {{rack.shelfs.length - (index)}}</div>
              </div>

              <div class="rack-list-operations-module" v-if="$store.state.user.role === 'HM'">
                <a  @click="removeLink(shelf.id)" class="top-nav__link">Отменить привязку</a>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div class="rack-list-navigation" :class="navClass">

        <div class="rack-list-navigation-item"
             v-for="rack in racks"
             title=""
        >
          <a href="#" @click.prevent="navClicked(rack.id)" class="rack-list-navigation-item__name">{{rack.title}}</a>
        </div>
      </div>

    </div>
  </div>
</template>

<script type="text/javascript">
  import axios from 'axios';
  import selectMaterial from '../../html/SelectMaterial';

  export default {
    name: 'rack-list',
    data() {
      return {
        racks: [],
        pharmacy: this.$route.params.id,
        copyTo: {},
        navClass: '',
      };
    },
    watch: {
      $route(to, from) {
        if (from.params.rack !== to.params.rack) {
          this.loadRacks();
        }
      },
    },
    components: { selectMaterial },
    methods: {
      loadRacks() {
        const self = this;

        if (this.$route.params.rack) {
          axios.get(`/api/v2/racks/${this.$route.params.rack}/`).then((response) => {
            self.isLoading = false;
            self.racks = [response.data];
          });
        } else {
          axios.get(`/api/v2/racks/?pharmacy=${self.pharmacy}`).then((response) => {
            self.isLoading = false;
            self.racks = response.data;
          });
        }
      },
      navClicked(rack) {
        const box = document.getElementById(rack).getBoundingClientRect();
        // console.log(box);
        window.scrollTo(0, box.top + window.pageYOffset);
      },
      handleScroll() {
        this.navClass = window.scrollY > 215 ? 'fixed' : '';
      },
      removeLink(id) {
        const self = this;
        if (confirm('Удалить свять с эталонной полкой?')) {
          axios.patch(`/api/v2/shelfs/${id}/`, { template_shelf: null }).then(() => {
            self.loadRacks();
          });
        }
      },
    },

    created() {
      this.loadRacks();
      window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll);
    },
  };
</script>


<style type="text/css" scoped="true" lang="less">
  .rack-list{
    margin: 0 -8px;
    padding-top: 20px;
  }

  .has-changes {
    border-radius: 50%;
    width: 10px;
    height: 10px;
    background: lightcoral;
    position: absolute;
    left: -20px;
    top: 5px;
    font-size: 0;
  }

  .rack-list-item{
    position: relative;
    vertical-align: top;
    width: 600px;
    margin: 0 auto 16px;

    &__name{
      font-size: 16px;
      margin-bottom: 4px;
      color: #3F6FA7;

      span{
        border-bottom: 1px solid #3F6FA7;
        cursor: pointer;
      }

    }

    &__group{
      margin-bottom: 16px;
      font-size: 14px;

    }


  }

  .rack-list-operations{
    display: inline-block;
    vertical-align: top;
    width: 400px;
    margin: 0 8px 16px;
  }

  .rack-list-operations-module {
    background: #FFFFFF;
    margin-bottom: 4px;
    font-size: 12px;
    padding: 10px;
    text-align: left;
    position: absolute;
    bottom: -4px;
    left:0;
    right: 0;
    display: none;
  }

  .rack-list-shelf{
    background: #FFFFFF;
    border-radius: 8px;
    margin-bottom: 4px;
    text-align: center;
    font-size: 26px;
    cursor: pointer;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    position: relative;
    padding-top: 30px;

    .has-changes {
      left: auto;
      right: 10px;
    }

    &--template {
      background: lightyellow;
    }

    &__height, &__number{
      font-size: 12px;
      line-height: normal;
      text-align: right;
      top: 10px;
      position: absolute;
      right: 10px;
    }

    &__number {
      right: auto;
      left: 10px;
    }

    &__image{
      display: block;
      width: 100%;
    }

    &:hover{
      .rack-list-operations-module {
        display: block;
      }
    }
  }

  .material-select{
    display: inline-block;
  }


  .rack-list-navigation {
    position: absolute;
    font-size: 14px;
    top: 60px;
    left: 50%;
    margin-left: 360px;

    &.fixed{
      position: fixed;
      top: 15px;
      width: 400px;
      left: 50%;
      margin-left: 360px;
    }
  }

  .rack-list-navigation-item {
    margin-bottom: 10px;

    &__name {
      color:#3F6FA7;
      text-decoration: none;
      border-bottom: 1px dotted #3F6FA7;
    }
  }

  @media print {
    .rack-list-item{
      display: block;
      width: auto;
      page-break-after: always;
      page-break-inside: avoid;
    }

    .rack-list-item__name{
      font-size: 44px;
      margin-bottom: 20px;
    }

    .rack-list-shelf{
      margin-bottom: 40px;
    }

    .rack-list-shelf__number{
      font-size: 30px;
    }

    .rack-list-shelf__image{
      margin-top: 30px;
    }

    .rack-list-navigation{
      display: none;
    }
  }


</style>


// WEBPACK FOOTER //
// RackList.vue?2eb6c1e0